import React from 'react';
import { Outlet } from 'react-router-dom';
import { PublicHeader } from '../components/commerce/PublicHeader';
import { Footer } from '../components/commerce/Footer';
import { MobileBottomNav } from '../components/commerce/MobileBottomNav';

export function PublicLayout() {
  return (
    <div className="min-h-screen bg-kelate-bg pb-16 md:pb-0">
      <PublicHeader />
      <Outlet />
      <Footer />
      <MobileBottomNav />
    </div>
  );
}
